// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-styles-containers-___CustomerEditor__button___WZmNg {
  background-color: transparent;
  border: none;
  border-radius: 3px;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
  color: #ffffff;
  padding: 0.75em 1em;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
  transition: all 0.15s cubic-bezier(0.35, 0, 0.25, 1);
}
.src-styles-containers-___CustomerEditor__button___WZmNg.src-styles-containers-___CustomerEditor__success___Jj7CC {
  background-color: #4ca92f;
  color: #ffffff;
}
.src-styles-containers-___CustomerEditor__button___WZmNg.src-styles-containers-___CustomerEditor__success___Jj7CC:hover {
  background-color: #3a8124;
  color: #ffffff;
}
.src-styles-containers-___CustomerEditor__button___WZmNg.src-styles-containers-___CustomerEditor__alert___HOf2W {
  background-color: #ff401e;
  color: #ffffff;
}
.src-styles-containers-___CustomerEditor__button___WZmNg.src-styles-containers-___CustomerEditor__alert___HOf2W:hover {
  background-color: #ea2400;
  color: #ffffff;
}
.src-styles-containers-___CustomerEditor__button___WZmNg:disabled,
.src-styles-containers-___CustomerEditor__button___WZmNg:disabled:hover {
  background-color: rgba(150, 150, 150, 0.5);
}
.src-styles-containers-___CustomerEditor__inputField___DMLOz {
  font-size: 1.5em;
  border: 1px solid rgba(150, 150, 150, 0.5);
  border-radius: 3px;
  padding: 0.2em;
  min-width: 300px;
  width: 100%;
}
.src-styles-containers-___CustomerEditor__customer--editor___xCyoD {
  padding: 1em;
}
.src-styles-containers-___CustomerEditor__label___KW3YN {
  margin-right: 0.5em;
  margin-bottom: 0.5em;
  display: block;
}
.src-styles-containers-___CustomerEditor__label___KW3YN div {
  display: inline-block;
  margin-left: 0.5em;
}
.src-styles-containers-___CustomerEditor__hidden___EraK5 {
  display: none;
}
.src-styles-containers-___CustomerEditor__customer--link___C5PwB {
  font-size: 1em;
  line-height: 0.5em;
  margin-left: 1em;
}
.src-styles-containers-___CustomerEditor__customer--link___C5PwB i {
  vertical-align: middle;
}
.src-styles-containers-___CustomerEditor__input___LNfHE {
  font-size: 1.5em;
  border: 1px solid rgba(150, 150, 150, 0.5);
  border-radius: 3px;
  padding: 0.2em;
  min-width: 300px;
  width: 100%;
  width: 50%;
}
.src-styles-containers-___CustomerEditor__save___tkwzu {
  margin-top: 1em;
}
.src-styles-containers-___CustomerEditor__delete-button___en8xP {
  margin-top: 1em;
  margin-left: 0.5em;
}
.errorMessage {
  margin-left: 0.5em;
  color: #ff401e;
}
div.src-styles-containers-___CustomerEditor__chartSelector___NolFx {
  display: flex;
  justify-content: space-between;
}
`, "",{"version":3,"sources":["webpack://./src/styles/mixins.less","webpack://./src/styles/containers/CustomerEditor.less"],"names":[],"mappings":"AAEA;EACE,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,0CAAA;EACA,cAAA;EACA,mBAAA;EACA,2CAAA;EACA,oDAAA;ACDF;ADGE;EACE,yBAAA;EACA,cAAA;ACDJ;ADGI;EACE,yBAAA;EACA,cAAA;ACDN;ADKE;EACE,yBAAA;EACA,cAAA;ACHJ;ADKI;EACE,yBAAA;EACA,cAAA;ACHN;ADOE;;EACE,0CAAA;ACJJ;ADQA;EACE,gBAAA;EACA,0CAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;ACNF;AAlCA;EACE,YAAA;AAoCF;AAjCA;EACE,mBAAA;EACA,oBAAA;EACA,cAAA;AAmCF;AAtCA;EAMI,qBAAA;EACA,kBAAA;AAmCJ;AA/BA;EACE,aAAA;AAiCF;AA9BA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;AAgCF;AAnCA;EAMI,sBAAA;AAgCJ;AA5BA;EDME,gBAAA;EACA,0CAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;ECTA,UAAA;AAmCF;AAhCA;EACE,eAAA;AAkCF;AA/BA;EACE,eAAA;EACA,kBAAA;AAiCF;AA9BA;EAEI,kBAAA;EACA,cAAA;AA+BJ;AA3BA;EACE,aAAA;EACA,8BAAA;AA6BF","sourcesContent":["@import './variables.less';\n\n.button {\n  background-color: transparent;\n  border: none;\n  border-radius: 3px;\n  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);\n  color: @color-main-white;\n  padding: 0.75em 1em;\n  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);\n  transition: @transition;\n  \n  &.success {\n    background-color: @color-main-green;\n    color: @color-main-white;\n\n    &:hover {\n      background-color: darken(@color-main-green, 10%);\n      color: @color-main-white;\n    }\n  }\n\n  &.alert {\n    background-color: @color-main-red;\n    color: @color-main-white;\n\n    &:hover {\n      background-color: darken(@color-main-red, 10%);\n      color: @color-main-white;\n    }\n  }\n\n  &:disabled, &:disabled:hover {\n    background-color: @color-main-gray;\n  }\n}\n\n.inputField {\n  font-size: 1.5em;\n  border: 1px solid @color-main-gray;\n  border-radius: 3px;\n  padding: 0.2em;\n  min-width: 300px;\n  width: 100%;\n}\n","@import '../variables.less';\n@import '../mixins.less';\n\n.customer--editor {\n  padding: 1em;\n}\n\n.label {\n  margin-right: 0.5em;\n  margin-bottom: 0.5em;\n  display: block;\n\n  div {\n    display: inline-block;\n    margin-left: 0.5em;\n  }\n}\n\n.hidden {\n  display: none;\n}\n\n.customer--link {\n  font-size: 1em;\n  line-height: 0.5em;\n  margin-left: 1em;\n\n  i {\n    vertical-align: middle;\n  }\n}\n\n.input {\n  .inputField();\n  width: 50%;\n}\n\n.save {\n  margin-top: 1em;\n}\n\n.delete-button {\n  margin-top: 1em;\n  margin-left: 0.5em;\n}\n\n:global {\n  .errorMessage {\n    margin-left: 0.5em;\n    color: @color-main-red;\n  }\n}\n\ndiv.chartSelector  {\n  display: flex;\n  justify-content: space-between\n}\n"],"sourceRoot":""}]);
// Exports
export var button = `src-styles-containers-___CustomerEditor__button___WZmNg`;
export var success = `src-styles-containers-___CustomerEditor__success___Jj7CC`;
export var alert = `src-styles-containers-___CustomerEditor__alert___HOf2W`;
export var inputField = `src-styles-containers-___CustomerEditor__inputField___DMLOz`;
var _1 = `src-styles-containers-___CustomerEditor__customer--editor___xCyoD`;
export { _1 as "customer--editor" };
export var label = `src-styles-containers-___CustomerEditor__label___KW3YN`;
export var hidden = `src-styles-containers-___CustomerEditor__hidden___EraK5`;
var _2 = `src-styles-containers-___CustomerEditor__customer--link___C5PwB`;
export { _2 as "customer--link" };
export var input = `src-styles-containers-___CustomerEditor__input___LNfHE`;
export var save = `src-styles-containers-___CustomerEditor__save___tkwzu`;
var _3 = `src-styles-containers-___CustomerEditor__delete-button___en8xP`;
export { _3 as "delete-button" };
export var chartSelector = `src-styles-containers-___CustomerEditor__chartSelector___NolFx`;
export default ___CSS_LOADER_EXPORT___;
